import request from '@/api';
import { getTags, getTagGroupList, getTagGroupsDetail, getTagGroupDetail, getTagGroupAndTagList, searchTracksByUid, SearchTagAndTagGroupOptions } from '@/api/gql/getTags.gql';

export const geTagsAPI = async () => {
  const res = await request(getTags);

  return res;
};

export const getTagGroupListAPI = async (payload) => {
  const res = await request(getTagGroupList, payload);

  return res;
};

export const getTagGroupsDetailAPI = async (payload) => {
  const res = await request(getTagGroupsDetail, payload);

  return res;
};

export const getTagGroupDetailAPI = async (payload) => {
  const res = await request(getTagGroupDetail, payload);

  return res;
};

export const getTagGroupAndTagListAPI = async (payload) => {
  const res = await request(getTagGroupAndTagList, payload);

  return res;
};

export const searchTracksByUidAPI = async (payload) => {
  const res = await request(searchTracksByUid, payload);

  return res;
};

export const searchTagAndTagGroupOptionsAPI = async (payload) => {
  const res = await request(SearchTagAndTagGroupOptions, payload);

  return res;
};
